import rules from "../../../utils/rules";
import apiService from "../../../api/api.service";
export default {
  name: "reset-password",
  data() {
    return {
      rules: rules,
      loading: false,
      showConfirmpass: true,
      showNewpass: true,
      newPassword: null,
      confirmPassword: null,
      validURL: false,
      token: "",
      userId: "",
      userName: null,
      confirmPasswordRules: [
        value => !!value || "Confirm password is required",
        value =>
          value === this.newPassword ||
          "The password confirmation does not match."
      ]
    };
  },
  mounted() {
    this.token = this.$route.query["token"];
    this.userId = this.$route.query["userid"];
    this.userName = this.$route.query["username"];
    if (!this.token || !this.userId || !this.userName) {
      this.validURL = false;
      this.backToLogin();
      this.$toast.error(
        "This is not a valid URL to change the password. Please try with the other URL."
      );
    } else {
      this.validURL = true;
    }
  },
  methods: {
    backToLogin() {
      this.$router.push("/signin");
    },
    async resetPasswordClick() {
      if (this.$refs.resetPasswordForm.validate() && this.validURL) {
        this.loading = true;
        let payload = {
          userId: this.userId,
          password: this.newPassword,
          token: this.token
        };
        try {
          let response = await apiService.setNewPassword(payload);
          this.loading = false;
          if (response && response.isSuccess) {
            this.$toast.success(
              response.systemMessage + " Please login with your new password"
            );
            this.$refs.resetPasswordForm.reset();
            this.backToLogin();
          } else {
            this.$toast.error(response.systemMessage);
          }
        } catch (error) {
          this.loading = false;
          this.$toast.error("Password couldn't be reset" + error);
        }
      }
    }
  }
};
